import { render, staticRenderFns } from "./FeatureCardPaihMigratorButton.vue?vue&type=template&id=b7824c96&"
import script from "./FeatureCardPaihMigratorButton.vue?vue&type=script&lang=js&"
export * from "./FeatureCardPaihMigratorButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports